import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

import { closeConfirmModal, openConfirmModal } from "actions";

import {
  addBidderRegistration,
  deleteBidderRegistration,
  updateBidderRegistration,
} from "actions/offline";

import BidderRegistrationForm from "components/BidderRegistrationForm";

import { getBidderById, selectBiddersList } from "selectors";

import { bidderFormValidationSchema } from "./validation";

const BidderRegistrationFormContainer = ({ bidderId, onCancel, onClose }) => {
  const dispatch = useDispatch();

  const isLoading = useSelector(state => state.bidderRegistrations.isFetching);
  const bidder = useSelector(getBidderById(bidderId)) || {};
  const biddersList = useSelector(selectBiddersList);

  const validationSchema = bidderFormValidationSchema(biddersList);
  const lastBidderRegistration = biddersList[0];
  const nextBidderNumber = lastBidderRegistration
    ? lastBidderRegistration.registrationNumber + 1
    : 1;
  const registrationNumber = bidder.registrationNumber
    ? bidder.registrationNumber
    : nextBidderNumber;
  const initialValues = { ...bidder, registrationNumber };
  const provisionalData = bidder?.provisionalData || {};

  const isEdit = Boolean(bidderId);
  const showCreateAnother = !isEdit;

  function handleSubmit(values) {
    const { createAnother } = values;
    if (isEdit) {
      dispatch(updateBidderRegistration(bidderId, values));
    } else {
      dispatch(addBidderRegistration(uuidv4(), values));
    }
    if (!createAnother && onClose) {
      onClose();
    }
  }

  const handleDelete = isEdit
    ? () => {
        dispatch(
          openConfirmModal({
            title: "Are you sure?",
            message:
              "Are you sure you want to delete this bidder registration?",
            actions: [
              {
                label: "No",
                secondary: true,
                onClick: () => dispatch(closeConfirmModal()),
              },
              {
                label: "Yes",
                onClick: () => {
                  dispatch(closeConfirmModal());
                  dispatch(deleteBidderRegistration(bidderId));
                  onCancel && onCancel();
                },
              },
            ],
          }),
        );
      }
    : null;

  return (
    <BidderRegistrationForm
      handleDelete={handleDelete}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      isLoading={isLoading}
      onCancel={onCancel}
      provisionalData={provisionalData}
      showCreateAnother={showCreateAnother}
      validationSchema={validationSchema}
      biddersList={biddersList}
    />
  );
};

export default BidderRegistrationFormContainer;
